import React from 'react'
import { Row, Col, Tabs } from 'antd'
import { connect } from 'react-redux'

import { LOGIN_PAGE } from '../../../../../../constants/constants'
import { changeTab } from 'store/actions/login'
import { useActions } from '../.././../../../hooks/useActions'

import GoogleForm from './GoogleForm'
import AsanForm from './AsanForm'
import SIMAForm from './SIMAForm'
import '../sidebar.scss'
import { useTranslation } from 'react-i18next'



const LoginForm = ({ tabValue, setPswStore, pswStore }) => {
  const { t } = useTranslation()
  const { changeTab } = useActions()
  const { TabPane } = Tabs

  const tabData: Array<any> = [
    {
      index: 1,
      name: 'Login',
      content: <GoogleForm type={'user'} setPswStore={setPswStore} pswStore={pswStore} />,
    },
    {
      index: 2,
      name: 'Google',
      content: <GoogleForm type={'google'} setPswStore={setPswStore} pswStore={pswStore} />,
    },
    {
      index: 3,
      name: 'Asan İmza',
      content: <AsanForm />,
    },
    {
      index: 4,
      name: 'SİMA',
      content: <SIMAForm />,
    },
  ]

  const handleTabChange = (e: string) => {
    changeTab(e)
  }

  return (
    <div style={{ width: '100%' }}>
      <Row style={{ width: '100%', margin: 0 }}>
        <Col  className="login-form">
          <h3>{t(LOGIN_PAGE.TITLE)}</h3>
          <Tabs
            id="login-tab"
            activeKey={`${tabValue}`}
            onChange={(e) => handleTabChange(e)}
            animated={false}
            destroyInactiveTabPane={true}
          >
            {tabData.map((item) => (
              <TabPane tab={item.name} key={item.index}>
                {item.content}
              </TabPane>
            ))}
          </Tabs>
        </Col>
      </Row>
    </div>
  )
}

const mapDispatchToProps = { changeTab }

const mapStateToProps = (state: any) => ({
  tabValue: state.login ? state.login.tabValue : '1',
})
export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)
